
import { Component, Vue } from 'vue-property-decorator';
import { PerformoSettings, UsersApi, User, Property } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    settings: 'settings',
    currentProperty: 'currentProperty'
  })
})
export default class MyProfile extends Vue {
  // user profile vuemodel
  private api = new UsersApi(this.$store.getters.getApiConfiguration);
  private settings!: PerformoSettings;
  private currentProperty!: Property;

  get currentUserName(): string {
    return this.user &&
      this.user.contact &&
      this.user.contact.firstName &&
      this.user.contact.lastName
      ? this.user.contact.firstName + ' ' + this.user.contact.lastName
      : this.$store.getters.userDisplayName;
  }

  private user: User = { contact: {} };

  private async mounted() {
    this.user = await this.api.getMyProfile();
  }
}
